import { render, staticRenderFns } from "./Customerjobs.vue?vue&type=template&id=63fee79b"
import script from "./Customerjobs.vue?vue&type=script&lang=js"
export * from "./Customerjobs.vue?vue&type=script&lang=js"
import style0 from "./Customerjobs.vue?vue&type=style&index=0&id=63fee79b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports